import {
    FaChalkboardTeacher, FaHeartbeat, FaSwatchbook, FaUserCheck, FaWalking, FaStar,
    // FaFileSignature,
    FaRegClipboard, FaHandshake,
    FaSignature
} from 'react-icons/fa'
import { AiOutlineUserSwitch } from "react-icons/ai";
import { BookIcon } from 'components/Icons'
import ListAltIcon from '@mui/icons-material/ListAlt';
import HomeIcon from '@mui/icons-material/Home'
import PeopleIcon from '@mui/icons-material/People'
import SchoolIcon from '@mui/icons-material/School'
import AnalyticsIcon from '@mui/icons-material/Analytics';
import { DescriptionIcon, LaptopIcon } from '../Icons'
import ScheduleIcon from '@mui/icons-material/CalendarMonth'
import HowToRegIcon from '@mui/icons-material/HowToReg'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import { FiAward } from 'react-icons/fi'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LaunchIcon from '@mui/icons-material/Launch';
import { createToken } from 'store/session';

export const menuItems = [
    {
        title: 'Dashboard',
        path: '/',
        icon: <HomeIcon />,
        contexts: ['provider', 'school'],
    },
    {
        title: 'Schools',
        path: '/schools',
        icon: <FiAward />,
        contexts: ['provider', 'school'],
    },
    {
        title: 'People',
        path: '/people',
        icon: <FaChalkboardTeacher />,
        permission: 'people.people',
        contexts: ['provider'],
    },
    {
        title: 'Staff',
        path: '/member/staff',
        icon: <PeopleIcon />,
        permission: 'staff.staff',
        contexts: ['provider', 'school'],
    },
    {
        title: 'Students',
        path: '/member/student',
        icon: <SchoolIcon />,
        permission: 'student.student',
        contexts: ['school'],
    },
    {
        title: 'Attendance',
        path: '/attendance',
        icon: <FaUserCheck />,
        permission: 'attendance.attendance',
        contexts: ['school'],
    },
    {
        title: 'Leave Request',
        path: '/leave-request',
        icon: <FaWalking />,
        permission: 'leave.leave',
        contexts: ['school', 'provider'],
    },
    {
        title: 'Scheduling',
        path: '/scheduling',
        icon: <FaSwatchbook />,
        permission: 'scheduling.scheduling',
        contexts: ['school'],
    },
    {
        title: 'Reports',
        path: '/reports',
        icon: <DescriptionIcon />,
        permission: 'report.report',
        contexts: ['provider', 'school'],
    },
    {
        title: 'Health',
        path: '/health',
        icon: <FaHeartbeat />,
        permission: 'nurse.nurse',
        contexts: ['school'],
    },
    {
        title: 'Calendar',
        path: '/calendar',
        icon: <CalendarMonthIcon />,
        permission: session => Boolean(session.academicYear),
        contexts: ['school'],
    },
    {
        title: 'Discipline',
        path: '/discipline',
        icon: <ListAltIcon />,
        permission: 'discipline.discipline',
        contexts: ['school'],
    },
    {
        title: 'Devices',
        path: '/asset-management',
        icon: <LaptopIcon />,
        permission: 'miscellaneous.device',
        contexts: ['provider', 'school'],
    },
    {
        title: 'Admin Evaluation',
        path: '/admin-evaluation',
        icon: <FaRegClipboard />,
        permission: 'evaluation.admin',
        contexts: ['provider', 'school'],
    },
    {
        title: 'Substitute Portal',
        path: '/substitute-portal',
        icon: <AiOutlineUserSwitch />,
        permission: 'substitute.substitute',
        contexts: ['school'],
    },
    {
        title: 'Admissions',
        path: '/admission',
        icon: <DescriptionIcon />,
        permission: 'application.application',
        contexts: ['provider', 'school'],
    },
    {
        title: 'Mentorship',
        path: '/mentorship/management',
        icon: <FaHandshake />,
        permission: session => Boolean(((session.permissions?.['mentorship.admin'] || session.permissions?.['mentorship.mentor']) && session.district?.isServiceProvider)),
        contexts: ['provider', 'school', 'teacher'],
    },
    {
        title: 'Visitor Log',
        path: '/visitor-log',
        icon: <AssignmentIndIcon />,
        permission: 'miscellaneous.visit',
        contexts: ['provider', 'school'],
    },

    {
        title: 'My Courses',
        path: '/academic/my-courses',
        icon: <BookIcon />,
        contexts: ['teacher'],
    },
    {
        title: 'My Schedule',
        path: '/academic/schedule',
        icon: <ScheduleIcon />,
        contexts: ['teacher'],
    },
    {
        title: 'My Attendance',
        path: '/academic/attendance',
        icon: <HowToRegIcon />,
        contexts: ['teacher'],
    },

    {
        title: 'My Grades',
        path: '/academic/grading-report',
        icon: <FaStar />,
        contexts: ['student'],
    },
    {
        title: 'My Schedule',
        path: '/academic/schedule',
        icon: <ScheduleIcon />,
        contexts: ['student'],
    },
    {
        title: 'My Attendance',
        path: '/academic/attendance',
        icon: <HowToRegIcon />,
        contexts: ['student'],
    },
    {
        title: 'Discipline Stats',
        path: '/academic/discipline-stats',
        icon: <AnalyticsIcon />,
        contexts: ['student'],
    },

    {
        title: 'Contacts',
        path: '/academic/contacts',
        icon: <PeopleIcon />,
        permission: session => session.person?.type === 'parent' && session.district?.type === 'school',
        contexts: ['student'],
    },

    {
        title: 'My Mentorship',
        path: '/mentorship/my-logs',
        icon: <FaHandshake />,
        contexts: ['provider', 'school'],
    },

    {
        title: 'E-Sign',
        path: '/academic/esign',
        icon: <FaSignature />,
        permission: session => session.person?.type === 'parent' && session.district?.type === 'school',
        contexts: ['student'],
    },

    {
        title: 'Legacy SIS',
        icon: <LaunchIcon />,
        // On click, dispatches createToken() and uses its response ({ link, token, selcamp })
        // to POST a hidden form to the legacy system in a new tab (see launchExternalForm / MenuItem).
        permission: session => session.person?.type === 'staff',
        externalForm: { tokenAction: createToken },
        contexts: ['provider', 'school'],
    }
]

// Returns menu items for a given context, preserving canonical order.
export const getMenuItems = context =>
    menuItems.filter(item => item.contexts.includes(context))

// Named exports — AppMenu/index.jsx imports these directly (no changes needed there).
export const providerMenu = getMenuItems('provider')
export const schoolMenu = getMenuItems('school')
export const admissionsMenu = getMenuItems('admissions')
export const academicMenu = getMenuItems('teacher')
export const studentMenu = getMenuItems('student')
export const mentorshipMenu = getMenuItems('mentee')
